import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { InputRow, Combobox, Select, DatePicker } from '@/components/ui/form';
    import { useI18n } from 'vue-i18n';
    import { useEmployeesInPayrollData } from '@/composables/useEmployeesInPayrollData';
    import { Payroll, Employee } from '@/types';
    // import { optionsYesNo } from '@/utils/form';
    // import { computed, watch } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveEmployeeFromPayrollForm',
  props: {
    form: {},
    payroll: {},
    employees: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const { employees: employeesInPayroll, isLoadingEmployees } = useEmployeesInPayrollData(
        props.payroll.id,
    );

    // const selectedEmployee = computed(() => {
    //     return props.employees.find((employee) => employee.id === props.form.employee_id);
    // });

    // const isTerminated = computed(() => {
    //     return selectedEmployee.value?.termination !== null;
    // });

    // watch(selectedEmployee, (newEmployee) => {
    //     if (newEmployee && newEmployee.termination) {
    //         props.form.termination_date = newEmployee.termination.termination_date;
    //     }
    // });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(InputRow), {
    form: _ctx.form,
    name: "employee_id",
    label: "payrolls.remove_employee_from_payroll.select_employee"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Combobox), {
        modelValue: _ctx.form.employee_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.employee_id) = $event)),
        options: _unref(employeesInPayroll),
        translate: false,
        placeholder: _unref(t)('payrolls.remove_employee_from_payroll.select_employee'),
        "label-by": "full_name",
        "value-by": "id",
        loading: _unref(isLoadingEmployees),
        "show-remove-button": false
      }, null, 8, ["modelValue", "options", "placeholder", "loading"])
    ]),
    _: 1
  }, 8, ["form"]))
}
}

})